export default __webpack_public_path__ + "static/media/logo.b47f7a21.png";